var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Vue from 'vue';
import { Component } from 'vue-property-decorator';
import * as API from './api';
let ScoringManage = class ScoringManage extends Vue {
    constructor() {
        super(...arguments);
        this.status = 'Idle';
        this.proset = '';
        this.normal_problems = '';
        this.bonus_problems = '';
        this.results = '';
        this.score_sums = '';
    }
    updateScores() {
        return __awaiter(this, void 0, void 0, function* () {
            this.status = 'Updating scores...';
            let results = yield API.refreshRank();
            this.status = 'Update scores: ' + results;
        });
    }
    computeScores() {
        return __awaiter(this, void 0, void 0, function* () {
            this.status = 'Computing scores...';
            let normal_list = this.normal_problems.split(' ').map(x => parseInt(x)).filter(isFinite);
            let bonus_list = this.bonus_problems.split(' ').map(x => parseInt(x)).filter(isFinite);
            let normal_scores = {};
            let bonus_scores = {};
            let normal_sum = 0;
            let bonus_sum = 0;
            let all_prosets = yield API.listProSet();
            if (all_prosets === 'Error') {
                this.status = 'Compute scores: Error';
                return;
            }
            let prosets = [];
            for (let proset of all_prosets) {
                if (proset.name === this.proset) {
                    let rankers = yield API.getRankWithScore(proset.uid);
                    if (rankers === 'Error') {
                        this.status = 'Compute scores: Error';
                        return;
                    }
                    let proset_scores = yield API.listProSumScore(proset.uid);
                    if (proset_scores === 'Error') {
                        this.status = 'Compute scores: Error';
                        return;
                    }
                    for (let prosumscore of proset_scores) {
                        if (normal_list.indexOf(prosumscore.uid) !== -1) {
                            normal_sum += prosumscore.sumscore;
                        }
                        if (bonus_list.indexOf(prosumscore.uid) !== -1) {
                            bonus_sum += prosumscore.sumscore;
                        }
                    }
                    for (let list of [normal_list, bonus_list]) {
                        for (let pid of list) {
                            if (proset_scores.find(p => p.uid == pid) === undefined) {
                                alert(`Problem ${pid} not in collection.`);
                                this.status = 'Compute scores: Error';
                                return;
                            }
                        }
                    }
                    for (let ranker of rankers) {
                        let normal_score = 0;
                        let bonus_score = 0;
                        for (let chal_id in ranker.results) {
                            let result = ranker.results[chal_id];
                            let score = 0;
                            for (let sub of result) {
                                score += sub[1];
                            }
                            if (normal_list.indexOf(parseInt(chal_id)) !== -1) {
                                normal_score += score;
                            }
                            if (bonus_list.indexOf(parseInt(chal_id)) !== -1) {
                                bonus_score += score;
                            }
                        }
                        normal_scores[ranker.profile.uid] = (normal_scores[ranker.profile.uid] || 0) + normal_score;
                        bonus_scores[ranker.profile.uid] = (bonus_scores[ranker.profile.uid] || 0) + bonus_score;
                    }
                }
            }
            let user_list = yield API.listUser();
            if (user_list === 'Error') {
                this.status = 'Compute scores: Error';
                return;
            }
            let uid_to_mail = {};
            for (let user of user_list) {
                uid_to_mail[user.uid] = user.mail;
            }
            this.score_sums = `Sum of normal problems: ${normal_sum}\nSum of bonus problems: ${bonus_sum}`;
            this.results = 'email normal_score bonus_score\n';
            for (let uid in normal_scores) {
                let normal_score = normal_scores[uid] || 0;
                let bonus_score = bonus_scores[uid] || 0;
                this.results += `${uid_to_mail[uid]} ${normal_score} ${bonus_score}\n`;
            }
            this.status = 'Compute scores: Success';
        });
    }
};
ScoringManage = __decorate([
    Component
], ScoringManage);
export default ScoringManage;



// WEBPACK FOOTER //
// ./src/ScoringManage.vue